import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * ### 安否確認(施設関係者)で送信する質問内容のマスタ API 操作クラス
 */
export default class OtherUserSafetyConfirmMasters {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * ### GET OtherUserSafetyConfirmMasters
   */
  public async get(userStore: LoginUser): Promise<Array<OtherUserSafetyConfirmMastersGetModel>> {
    const formatParams: any = {
      facilityId: userStore.loginUser.facilityId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.OtherUserSafetyConfirmMasters, formatParams);

    const response = await this.commonService.executeGet<Array<OtherUserSafetyConfirmMastersGetModel>>(
      userStore,
      requestUrl,
      this.constructor.name,
      {},
      HitomeqErrorType.REQUEST_RETRY,
      0
    );

    return response.data;
  }
}

export interface OtherUserSafetyConfirmMastersGetModel {
  /** 質問マスタID */
  id: number;
  /** 質問の項目名 */
  label: string;
  /** 質問の name 属性値 */
  name: string;
  /** 必須項目か */
  required: boolean;
  /** 説明文（空文字可能） */
  text: string;
  /** 入力種別 */
  inputType: OtherUserSafetyConfirmMasterInputType;
  /** 入力種別のオプション。inputType に応じて可変 */
  inputOptions: OtherUserSafetyConfirmMasterRadioInputOption | OtherUserSafetyConfirmMasterMultipleTextInputOption;
  /** 削除フラグ */
  deleteFlag: boolean;
  /** レコード作成日 */
  created: number;
  /** レコード更新日 */
  updated: number;
}

export enum OtherUserSafetyConfirmMasterInputType {
  RADIO = 0,
  MULTIPLE_TEXT = 1
}

/** 入力種別が0=ラジオの場合のオプション */
export interface OtherUserSafetyConfirmMasterRadioInputOption {
  /** 選択肢の表示情報 */
  choices: Array<OtherUserSafetyConfirmMasterRadioInputOptionChoices>;
}

export interface OtherUserSafetyConfirmMasterRadioInputOptionChoices {
  /** ラベル名 */
  label: string;
  /** 値 */
  value: string;
}

/** 入力種別が1=テキスト入力(複数行)の場合のオプション */
export interface OtherUserSafetyConfirmMasterMultipleTextInputOption {
  /** 質問の placeholder 属性値 */
  placeholder: string;
  /** 最大文字数 */
  maxLength: number;
}
